import SearchFilterSection from '@components/searchFilterSection/SearchFilterSection'
import { AssetsModule } from '@core/modules/digital-footprint/assets'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import { unifiedDevicesFilterModule } from '../../devices.filters'
import { FC, useMemo } from 'react'

const DevicesHeader: FC = () => {
    const { data: allAssets } = AssetsModule.useStore()

    const deviceAssets = useMemo(
        () => allAssets.filter((a) => a.asset_type === 'device'),
        [allAssets]
    )

    const {
        search,
        filterConfig,
        data: filteredDevices,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
        activeFilters,
    } = useUnifiedFilter({
        filterModule: unifiedDevicesFilterModule,
        data: deviceAssets,
    })

    return (
        <SearchFilterSection
            allItems={deviceAssets}
            filteredItems={filteredDevices}
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
            getFilterOptions={getFilterOptions}
            filterConfig={filterConfig}
            searchValue={search}
            activeFilters={activeFilters}
            searchPlaceholder="Search devices..."
            itemLabel="devices"
            onFilterReset={handleFilterReset}
        />
    )
}

export default DevicesHeader
